/* NoamReasoning — état d'attente élégant pendant que NOAM raisonne (30-120s).
 * Montre uniquement des informations réelles : la progression du job et
 * le nombre de modules réellement présents dans le contexte. */
import { Sparkles } from "lucide-react";

export default function NoamReasoning({ progress, modulesCount }) {
  return (
    <div className="flex justify-start" data-testid="v2-reasoning">
      <div className="rounded-2xl rounded-bl-md border border-[#378ADD]/20 bg-[#0D1117] px-5 py-3.5 max-w-[85%]">
      <div className="flex items-center gap-2.5">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#378ADD] opacity-60" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#378ADD]" />
        </span>
        <span className="text-xs text-zinc-300">{progress || "NOAM raisonne…"}</span>
      </div>
      <div className="mt-1.5 text-[10px] text-zinc-500 flex items-center gap-1.5">
        <Sparkles className="w-3 h-3 text-[#378ADD]/70" />
        {modulesCount > 0
          ? `NOAM parcourt son modèle de votre environnement (${modulesCount} modules de contexte).`
          : "NOAM parcourt son modèle de votre environnement."}
      </div>
      </div>
    </div>
  );
}
